<!--  -->
<template>
    <div>
        <div class="remarks">
            <div class="title-warp">
                <div class="title">
                    检查意见
                </div>
                <div class="radio-group">
                    <el-radio-group v-model="formData.qualifiedSelect" style="margin-top: 10px"
                        :disabled="pageType == 'record' ? true : false" lable="检查意见" @change="setSession">
                        <el-radio :label="1">合格</el-radio>
                        <el-radio :label="2">不合格</el-radio>
                    </el-radio-group>
                </div>
            </div>
            <div class="check-cotent">
                <el-input v-model.trim="formData.remarks" type="textarea" :row="2" style="width: 100%" maxlength="200"
                    placeholder="请输入详细检查意见" :disabled="pageType == 'record' ? true : false" @blur="setSession"></el-input>
            </div>
        </div>
        <div class="classification">

            <div class="conditions">
                <div style="margin-top:16px">
                    <el-form ref="formRef" :model="formRef" :inline="true">
                        <el-form-item prop="goodsCode" label="商品编码" label-width="70px">
                            <el-input v-model="formRef.goodsCode" size="small" placeholder="请输入内容"></el-input>
                        </el-form-item>
                        <el-form-item prop="medicineCode" label="商品ERP编码">
                            <el-input v-model="formRef.medicineCode" size="small" placeholder="请输入内容"></el-input>
                        </el-form-item>
                        <el-form-item prop="goodsName" label="商品名称">
                            <el-input v-model="formRef.goodsName" size="small" placeholder="请输入内容"></el-input>
                        </el-form-item>
                        <el-form-item prop="factory" label="生产厂家">
                            <el-input v-model="formRef.factory" size="small" placeholder="请输入内容"></el-input>
                        </el-form-item>
                        <el-form-item prop="" label="检查意见">
                            <el-select v-model="formRef.qualifiedSelect" size="small" placeholder="请选择" style="width: 100%">
                                <el-option v-for="(e, i) in selectList" :key="i" :label="e.name" :value="e.id" />
                            </el-select>
                        </el-form-item>

                        <el-form-item>
                            <el-button type="primary" size="small" @click="getTableList(1)">查询</el-button>
                        </el-form-item>
                        <el-form-item>
                            <el-button size="small" @click="resetForm">重置</el-button>
                        </el-form-item>
                    </el-form>
                </div>

                <Tabs :tabsList="tabsList" :activeName.sync="activeName" @tab-click="handleChange" />
            </div>
            <div class="center" style="position:relative">
                <Table :tableData="tableData" :activeName="activeName" :selectionList="selectionList" :page="page"
                    :pageType="pageType" @saveTemporaryCheck="saveTemporaryCheckFn" @getList="getList"
                    @handleSelectionChange="handleSelectionChange" style="width: 100%;height: 100%;">
                </Table>
            </div>
        </div>
    </div>
</template>
  
<script>
// import MyTable from '@/components/myTable'
import Table from './table'
import Tabs from '@/components/Tabs'
import { getSkuListForCheck } from '@/api/product'
import avater from "/public/img/default.png"
import {
    saveTemporaryCheck,
    queryCheckRecordDetail
} from "@/api/shopmange";

export default {
    name: 'checkShop_goods',
    components: { Tabs, Table },
    props: {
        //pageType: check 检查，record 记录
        pageType: {
            type: String,
            default: 'check'
        }
    },
    data() {
        return {
            isRecord: false,
            formData: {
                qualifiedSelect: 0,
                remarks: '',
                shopId: ''
            },
            activeName: 'ON_SALE',
            selectList: this.pageType == 'record' ? [

                {
                    name: "合格",
                    id: 1,
                },
                {
                    name: "不合格",
                    id: 2,
                }
            ]
                : [
                    {
                        name: "待检查",
                        id: 0,
                    },
                    {
                        name: "合格",
                        id: 1,
                    },
                    {
                        name: "不合格",
                        id: 2,
                    }
                ]
            ,
            tabsList: [ // tabs 传的值
                {
                    name: 'ON_SALE',
                    label: '销售中',
                    value: 0,
                },
                {
                    name: 'MERCHANT_REMOVAL',
                    label: '商家下架',
                    value: 0,
                },
                {
                    name: 'PLATFORM_REMOVAL',
                    label: '平台下架',
                    value: 0,
                },

                {
                    name: 'SKU_AWAIT',
                    label: '上架待审核',
                    value: 0,
                },

                {
                    name: 'SKU_FAIL',
                    label: '商品审核未通过',
                    value: 0,
                }
            ],
            goodsOneClassIdOptions: [],
            goodsTwoClassIdOptions: [],
            goodsThreeClassIdOptions: [],
            avater: avater,
            formRef: { 
                goodsCode: '',
                medicineCode: '',
                goodsName: '',
                factory: '',
                qualifiedSelect: ''
            },

            formTool: {
                // goodsOneClassId: '',
                // goodsTwoClassId: '',
                // goodsThreeClassId: '',
            },
            selectionList: [],
            operation: true,
            selection: true,
            index: true,
            tableData: [],
            tableOption: [
                { label: '商品信息', prop: 'image', slot: true, minWidth: '200px' }, // 这里表示自定义列
                // { label: '商品名称', prop: 'name' },
                // { label: '生产厂商', prop: 'factory' },
                { label: '批准文号', prop: 'approvalNumber', width: "260px" },
                { label: '商品属性', prop: 'type' },
                { label: 'ERP编码', prop: 'medicineCode' },
                { label: '发布时间', prop: 'createTime', width: "180px" }
            ],
            page: {
                total: 0,
                current: 1,
                size: 20,
                pageSizes: [10, 20, 30, 50]
            }
        }
    },
    computed: {},
    watch: {},
    created() {

    },
    mounted() {
        this.getSeesion();
        this.getTableList()
    },
    beforeCreate() { },
    beforeMount() { },
    beforeUpdate() { },
    updated() { },
    beforeDestroy() { },
    destroyed() { },
    activated() { },
    methods: {
        // 保存资质细项检查结果（临时表）
        saveTemporaryCheckFn(item) {
            let parmas = item;
            parmas.shopId = this.$route.query.shopId;
            saveTemporaryCheck(parmas, 'product').then(res => { }).catch(err => { })
        },
        // 获取session,回显
        getSeesion() {
            this.formData.shopId = this.$route.query.shopId;
            let checkShopItemSession = window.sessionStorage.getItem('checkShopItemSession');
            if (checkShopItemSession && this.pageType == 'check') {
                checkShopItemSession = JSON.parse(checkShopItemSession);
                if (checkShopItemSession.shopId == this.formData.shopId) {
                    this.formData.qualifiedSelect = checkShopItemSession.goods.qualifiedSelect;
                    this.formData.remarks = checkShopItemSession.goods.remarks;
                }
            }


        },
        setSession() {
            this.formData.shopId = this.$route.query.shopId;
            let checkShopItemSession = window.sessionStorage.getItem('checkShopItemSession');
            if (checkShopItemSession) {
                checkShopItemSession = JSON.parse(checkShopItemSession);
                if (checkShopItemSession.shopId == this.formData.shopId) {
                    checkShopItemSession.goods.qualifiedSelect = this.formData.qualifiedSelect;
                    checkShopItemSession.goods.remarks = this.formData.remarks;
                    window.sessionStorage.setItem('checkShopItemSession', JSON.stringify(checkShopItemSession));
                }
            }
            // window.sessionStorage('checkStatus')
        },

        //切换tabs按钮
        handleChange() {
            this.getTableList(1)
        },

        // 重置查询条件
        resetForm() {
            this.page.current = 1
            this.page.size = 10
            this.$refs.formRef.resetFields()
            this.formRef.qualifiedSelect = '';
            this.getList(1);
        },

        // 切换分页
        getList(page) {
            page.current ? this.page.current = page.current : this.page.current = 1;
            this.page.size = page.size ? page.size : 10;
            this.getTableList(page.current)
        },
        // 勾选
        handleSelectionChange(val) {
            this.selectionList = val
            console.log(val)
        },
        // 查询
        getTableList(current) {
            if (current) { // 搜索条件改变从第一页开始查询
                this.page.current = current
            }
            const {
                shopId,
            } = this.$route.query;

            this.shopId = shopId;
            const params = {
                ...this.formRef,
                status: this.activeName,
                shopId: this.shopId,
                current: this.page.current,
                size: this.page.size
            }

            // ?current=1&size=10&shopId=1606205771220635650&status=ON_SALE
            // console.log(params)
            if (this.pageType == 'record') {
                console.log('查询goods 记录')
                params.type = 2;
                params.recordId = this.$route.query.recordId;
                this.queryCheckRecordDetailFn(params);
            } else {
                getSkuListForCheck(params).then(res => {
                    if (res) {
                        this.tableData = res.page.records
                        this.page.total = res.page.total
                        this.tabsList[0].value = res.staticVo.onSaleCount
                        this.tabsList[1].value = res.staticVo.merchantRemovalCount
                        this.tabsList[2].value = res.staticVo.platformRemovalCount
                        this.tabsList[3].value = res.staticVo.skuAwaitCount
                        this.tabsList[4].value = res.staticVo.skuFailCount
                    } else {
                        this.tableData = []
                        this.page.total = 0
                    }
                })
            }

        },


        // 查询检查记录列表 检查类型  type 1-资质 2-商品 3-订单 4-售后订单
        // recordId 检查记录id
        queryCheckRecordDetailFn(params) {
            params.goodsStatus = params.status;
            queryCheckRecordDetail(params).then(res => {
                if (res && res.checkRecordDetails) {
                    this.formData.qualifiedSelect = res.globalQualifiedSelect;
                    this.formData.remarks = res.remarks;
                    this.tableData = res.checkRecordDetails.records
                    this.page.total = res.checkRecordDetails.total
                    this.tabsList[0].value = res.goodsSkuCountStaticVO.onSaleCount
                    this.tabsList[1].value = res.goodsSkuCountStaticVO.merchantRemovalCount
                    this.tabsList[2].value = res.goodsSkuCountStaticVO.platformRemovalCount
                    this.tabsList[3].value = res.goodsSkuCountStaticVO.skuAwaitCount
                    this.tabsList[4].value = res.goodsSkuCountStaticVO.skuFailCount
                } else {
                    this.tableData = []
                    this.page.total = 0
                }

            }).catch(err => {

            });
        }

    }
}
</script>
<style lang='scss' scoped>
.classification {
    padding: 0px;
}

.header {
    height: 56px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0px 24px 0px 24px !important;
    border-bottom: 1px solid #f5f5f5;

    .font {
        font-size: 16px;
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: 600;
        text-align: left;
        color: #262626;
    }

    .el-form-item {
        margin: 0px 0px 0px 8px !important;
    }
}

.conditions {
    // padding: 0 24px 0 24px;
}

.center {
    margin-top: 16px;
    padding: 0 24px 0 24px;
    height: calc(100% - 305px);

    ::v-deep .imageP {

        // width: calc(100% - 110px);
        p {
            margin: 0 0 0 0px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
}

::v-deep .el-form-item {
    margin-bottom: 10px !important;
}


.remarks {
    background: #ffffff;
    padding: 0 0px 20px;

    .title-warp {
        display: flex;
    }

    .title {
        line-height: 30px;
        font-size: 16px;
        // width: 200px;
        //display: flex;
        // justify-content: space-between; 
    }

    .radio-group {
        margin-left: 10px;
    }
}
</style>
  